import { forwardRef, useState, type InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { cn } from '@/lib/utils';

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  hasError?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { className, hasError = false, ...inputProps },
  forwardedRef
) {
  const { t } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative">
      <input
        ref={forwardedRef}
        type={isVisible === true ? 'text' : 'password'}
        className={cn(
          'w-full px-4 py-2.5 pr-12 bg-zoooffwhite border rounded-xl text-zooindigo transition-all placeholder:text-zoomuted focus:outline-none focus:border-zooprimary focus:ring-2 focus:ring-zooprimary/40 disabled:bg-zoodisabledbg disabled:text-zoodisabledtext',
          hasError ? 'border-zooerrorborder ring-1 ring-zooerrorborder' : 'border-zooborder',
          className
        )}
        {...inputProps}
      />
      <button
        type="button"
        aria-label={isVisible === true ? t('actions.hidePassword') : t('actions.showPassword')}
        onClick={function toggleVisibility() {
          setIsVisible(isVisible === false);
        }}
        className="absolute right-1 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-lg text-zoomuted hover:text-zooindigo transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary"
      >
        <Icon name={isVisible === true ? 'EyeOff' : 'Eye'} />
      </button>
    </div>
  );
});
